import { render, staticRenderFns } from "./ModalSuggestNCCN.vue?vue&type=template&id=40ea1c65&scoped=true"
import script from "./ModalSuggestNCCN.vue?vue&type=script&lang=js"
export * from "./ModalSuggestNCCN.vue?vue&type=script&lang=js"
import style0 from "./ModalSuggestNCCN.vue?vue&type=style&index=0&id=40ea1c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea1c65",
  null
  
)

export default component.exports